
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $8d1ddd56c2f538ed$exports = {};
$8d1ddd56c2f538ed$exports = import.meta.resolve("19fIv");


var $5e9b598ed2e47fe7$exports = {};
$5e9b598ed2e47fe7$exports = import.meta.resolve("g6laN");


const $31bdeaf007ae8399$var$header_nav = document.querySelector('header > nav');
window.onload = function() {
    if (window.innerWidth < 1133) $31bdeaf007ae8399$var$hideMenu();
};
window.addEventListener('resize', ()=>{
    if (window.innerWidth < 1133) $31bdeaf007ae8399$var$hideMenu();
    else $31bdeaf007ae8399$var$showMenu();
});
function $31bdeaf007ae8399$var$hideMenu() {
    const header_nav = document.querySelector('header > nav');
    const menu_button = document.querySelector('#menu-button');
    header_nav.style.display = 'none';
    menu_button.style.background = `url('${0, (/*@__PURE__*/$parcel$interopDefault($8d1ddd56c2f538ed$exports))}')`;
}
function $31bdeaf007ae8399$var$showMenu() {
    const header_nav = document.querySelector('header > nav');
    const menu_button = document.querySelector('#menu-button');
    header_nav.style.display = 'block';
    menu_button.style.background = `url('${0, (/*@__PURE__*/$parcel$interopDefault($5e9b598ed2e47fe7$exports))}')`;
}
window.toggleMenu = function() {
    const header_nav = document.querySelector('header > nav');
    if (header_nav.style.display === 'block') $31bdeaf007ae8399$var$hideMenu();
    else $31bdeaf007ae8399$var$showMenu();
};


//# sourceMappingURL=pages.97e90761.js.map
